import {StorageInterface, StorageOptions} from './index';
import Cookies from 'js-cookie';

const STORAGE_PREFIX = 'npotag_';

export class CookieStorage implements StorageInterface {
  private readonly domain: string | undefined;

  constructor(domain?: string) {
    this.domain = domain;
  }

  get(key: string): string | undefined {
    // Prefer the prefixed key; fall back to the legacy unprefixed key for users
    // who had localStorage blocked and were previously writing raw cookie names.
    const prefixed = Cookies.get(STORAGE_PREFIX + key);
    if (prefixed !== undefined) {
      return prefixed;
    }
    const legacy = Cookies.get(key);
    if (legacy !== undefined) {
      // Migrate: write under the new prefix and remove the legacy cookie.
      this.set(key, legacy);
      Cookies.remove(key, {domain: this.domain});
      return legacy;
    }
    return undefined;
  }

  set(key: string, value: string, options?: StorageOptions): void {
    Cookies.set(STORAGE_PREFIX + key, value, {
      expires: options && options.expires,
      domain: this.domain,
      secure: window.location.protocol === 'https:',
      sameSite: 'Lax',
    });
  }

  remove(key: string) {
    Cookies.remove(STORAGE_PREFIX + key, {domain: this.domain});
  }
}
